import { DynamicElementType } from '@/lib/constants';
import React from 'react';

interface DynamicElementProps {
    type: DynamicElementType;
    children: React.ReactNode;
}

const DynamicElement: React.FC<DynamicElementProps | any> = ({ type = "p", children, ...props }) => {
    const Component = React.createElement(type, props, children);

    return <>{Component}</>;
};

export default DynamicElement;
